import { SUPPLIERS_QUERY } from "@/apis/gql/apolloClient";
import type { Supplier } from "@/apis/gql/types";
import { useTenant } from "@/providers/session";
import { useQuery } from "@apollo/client";

export const useGetAllSuppliers = ({
  type = "creditor",
}: {
  type?: "creditor" | "debtor";
} = {}) => {
  const { tenantId } = useTenant();
  const { data, error, loading, refetch } = useQuery<{ suppliers: Supplier[] }>(
    SUPPLIERS_QUERY,
    {
      variables: { tenantId, type },
    },
  );

  return { data: data?.suppliers ?? [], error, loading, refetch };
};
